import { Context } from '../../context/Context';
import { VertexBuffer } from '../../mesh';

/**
 * Unit cube whose vertex positions double as world-space view directions in
 * the standard "skybox" vertex shader trick. Shared between {@link SkyBox}
 * (image cubemap) and {@link ProceduralSky} (analytical scattering) — both
 * shaders bind position at attribute location 0.
 */
const SKY_CUBE_VERTICES: ReadonlyArray<number> = [
  -1.0, 1.0, -1.0, -1.0, -1.0, -1.0, 1.0, -1.0, -1.0, 1.0, -1.0, -1.0, 1.0, 1.0, -1.0, -1.0, 1.0,
  -1.0,

  -1.0, -1.0, 1.0, -1.0, -1.0, -1.0, -1.0, 1.0, -1.0, -1.0, 1.0, -1.0, -1.0, 1.0, 1.0, -1.0, -1.0,
  1.0,

  1.0, -1.0, -1.0, 1.0, -1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, -1.0, 1.0, -1.0, -1.0,

  -1.0, -1.0, 1.0, -1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, -1.0, 1.0, -1.0, -1.0, 1.0,

  -1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, -1.0, 1.0, 1.0, -1.0, 1.0, -1.0,

  -1.0, -1.0, -1.0, -1.0, -1.0, 1.0, 1.0, -1.0, -1.0, 1.0, -1.0, -1.0, -1.0, -1.0, 1.0, 1.0, -1.0,
  1.0,
];

export interface SkyCubeGeometry {
  buffer: VertexBuffer;
  vao: WebGLVertexArrayObject;
}

export function createSkyCubeGeometry(ctx: Context): SkyCubeGeometry {
  const gl = ctx.gl;

  const buffer = new VertexBuffer(gl.createBuffer(), gl.TRIANGLES, 0, 0);
  gl.bindBuffer(gl.ARRAY_BUFFER, buffer.glVertexBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(SKY_CUBE_VERTICES), gl.STATIC_DRAW);
  buffer.itemSize = 3;
  buffer.itemCount = SKY_CUBE_VERTICES.length / 3;

  const vao = gl.createVertexArray()!;
  gl.bindVertexArray(vao);
  gl.bindBuffer(gl.ARRAY_BUFFER, buffer.glVertexBuffer);
  gl.enableVertexAttribArray(0);
  gl.vertexAttribPointer(0, 3, gl.FLOAT, false, 0, 0);
  gl.bindVertexArray(null);

  return { buffer, vao };
}
